import React from 'react';
import Headline from './HomePage/Headline';
import HeroSection from './HomePage/HeroSection';
import Client from './HomePage/clients';
import TncFooter from './tncPages/tncLinks';
import YouTubeVideoPlayer from './HomePage/YouTubeVideoPlayer'

const Home = () => {
  return (
    <div className="text-white font-poppins mt-0 p-0 overflow-x-hidden" style={{backgroundColor: '#faf9f6  '}}>
      {/* Main Content */}
      <div className="relative min-h-screen w-full">
        {/* Headline Section */}
        <Headline />

        {/* Hero Section */}
        <main className="pt-0 w-full mb-0">
          <div className="hero w-full">
            <HeroSection />
          </div>

         {/* Client Section */}
{/* Client Section */}
<div className="hero-container mx-auto w-full  py-0 mb-24 pb-0 opacity-0 animate__animated animate__fadeInDown animate__delay-1.5s mt-[384px] sm:mt-0 h-[600px] sm:h-auto">
  <Client />
</div>



          {/* Video Section */}
         <div
className="youtube flex flex-col justify-center items-center py-12 sm:py-16 lg:py-auto w-full"
style={{ 
  background: 'rgb(39, 39, 39)', // Google Material Blue Grey 900 (rich dark blue-gray)
  // Bonus: Add subtle texture for depth:
  backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)',
  backgroundSize: '16px 16px'
}}
>
  <YouTubeVideoPlayer 
    videoUrl="https://www.youtube.com/watch?v=5hKxKV8MyM0" 
    title="केंद्र सरकारी कर्मचाऱ्यांसाठी खुशखबर! ८वा वेतन आयोगाची माहिती II"
  />
</div>

        </main>
        <div className='tnclinks'>
        <TncFooter/>
        </div>
      </div>
    </div>
  );
};

export default Home;
